/**
 * FireAnimation — flickering flame emoji with rising sparks.
 * Sparks pop up + drift outward on staggered timing to sell the heat.
 */
export default function FireAnimation({ size = 140 }) {
  return (
    <div
      className="pointer-events-none"
      style={{ width: size, height: size, position: "relative" }}
    >
      <style>{`
        @keyframes fire-flicker {
          0%   { transform: scale(0.5) rotate(-4deg); opacity: 0; filter: drop-shadow(0 0 0 rgba(251,146,60,0)); }
          20%  { transform: scale(1.5) rotate(3deg);  opacity: 1; filter: drop-shadow(0 0 40px rgba(251,146,60,0.9)); }
          40%  { transform: scale(1.3) rotate(-3deg); opacity: 1; filter: drop-shadow(0 0 30px rgba(239,68,68,0.9)); }
          60%  { transform: scale(1.4) rotate(2deg);  opacity: 1; filter: drop-shadow(0 0 34px rgba(251,146,60,0.9)); }
          80%  { transform: scale(1.2) rotate(-2deg); opacity: 0.9; filter: drop-shadow(0 0 24px rgba(239,68,68,0.7)); }
          100% { transform: scale(1) rotate(0deg);    opacity: 0; filter: drop-shadow(0 0 0 rgba(251,146,60,0)); }
        }
        @keyframes fire-spark-up {
          0%   { transform: translate(0, 0) scale(0.4); opacity: 0; }
          20%  { opacity: 1; }
          100% { transform: translate(var(--dx, 0), -160%) scale(0.1); opacity: 0; }
        }
      `}</style>
      <div
        style={{
          position: "absolute",
          inset: 0,
          fontSize: size * 0.72,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "fire-flicker 1.4s ease-in-out forwards",
        }}
      >
        🔥
      </div>
      {/* Rising sparks */}
      {[
        { dx: "-8px",  delay: "0.05s", left: "50%", color: "#fb923c" },
        { dx: "16px",  delay: "0.18s", left: "44%", color: "#ef4444" },
        { dx: "-20px", delay: "0.3s",  left: "56%", color: "#fbbf24" },
        { dx: "10px",  delay: "0.42s", left: "48%", color: "#fb923c" },
        { dx: "-4px",  delay: "0.55s", left: "52%", color: "#f97316" },
      ].map((s, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: s.left,
            top: "68%",
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: s.color,
            boxShadow: `0 0 12px ${s.color}`,
            transform: "translateX(-50%)",
            animation: `fire-spark-up 1.4s ease-out ${s.delay} forwards`,
            "--dx": s.dx,
          }}
        />
      ))}
    </div>
  );
}
